// extracted by mini-css-extract-plugin
module.exports = {"userManagementWrapper":"UserManagement_userManagementWrapper__TAm2E","title":"UserManagement_title__3OF_K","seperator":"UserManagement_seperator__1a6G3"};